import { makeStyles } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles((theme) => ({
    yellowBoxText: {
        background: "#F4B827", padding: "6px 16px", fontSize: 14, fontWeight: 700, color: "#03090E", borderRadius: 4, marginLeft: 5, cursor: "pointer",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    },

}));

const YellowBox = ({ title, onClick = null }: any) => {
    const classes = useStyles();
    if (!title) return null;
    return (
        <span onClick={onClick} className={classes.yellowBoxText} >
            {title}
        </span>
    )
}

export default YellowBox;